import React, { Component } from 'react';
import {Link} from 'react-router';
import IconButton from 'material-ui/IconButton';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import ButtonLoader from 'components/loaders/ButtonLoader';
import { downloadSingleExcel, downloadSinglePdf, downloadSingleCsv } from 'actions/crashboxxServicesActions';
import styles from '../styles/LinkToDetailsCellRenderStyles';
import excelImg from 'Content/Assets/images/excel-icon_20.png';
import pdfImg from 'Content/Assets/images/PDF_original.png';

class LinkToDetailsExpandedCellRender extends Component {
    constructor(props) {
        super(props);
        this.handleDownloadPDFClick = this.handleDownloadPDFClick.bind(this);
        this.handleDownloadExcelClick = this.handleDownloadExcelClick.bind(this);
        this.handleDownloadCSVClick = this.handleDownloadCSVClick.bind(this);
    }

    handleDownloadPDFClick(event){
        event.preventDefault()
        this.props.downloadSinglePdf(this.props.data.icn.id, this.props.fields.isIcnPlus, this.props.fields.isDent);
    }

    handleDownloadExcelClick(event){
        event.preventDefault()
        this.props.downloadSingleExcel(this.props.data.icn.id, this.props.fields.isIcnPlus, this.props.fields.isDent);
    }

    handleDownloadCSVClick(event){
        event.preventDefault()
        this.props.downloadSingleCsv(this.props.data.icn.id, this.props.fields.isIcnPlus, this.props.fields.isDent);
    }

    render() {
        var {fields, data, isPdfLoading, isExcelLoading, isCsvLoading} = this.props;

        return (
        <div>
            {
                fields.showSingleExport && fields.showSingleExport === true ?
                    <div>
                        {
                            isPdfLoading ? <ButtonLoader />
                            :
                            <FlatButton onClick={this.handleDownloadPDFClick}
                                icon={
                                    <Avatar
                                                src={pdfImg}
                                                size={25}
                                                style={styles.excelIcon}
                                            />
                                }
                                style={styles.iconFlatButton}
                            />
                        }
                        {
                            isExcelLoading ? <ButtonLoader />
                            :
                            <FlatButton onClick={this.handleDownloadExcelClick}
                                icon={
                                    <Avatar
                                                src={excelImg}
                                                size={25}
                                                style={styles.excelIcon}
                                            />
                                }
                                style={styles.iconFlatButton}
                            />
                        }

                        {
                            isCsvLoading ? <ButtonLoader />
                            :

                            <FlatButton onClick={this.handleDownloadCSVClick}
                                icon={
                                    <Avatar
                                                src={excelImg}
                                                size={25}
                                                style={styles.excelIcon}
                                            />
                                }
                                style={styles.iconFlatButton}
                            />
                        }
                        <Link to={fields.linkGoToDetails + data.icn.id}>
                            <IconButton
                                    iconClassName="material-icons">
                                    keyboard_arrow_right
                            </IconButton>
                        </Link>
                    </div>
                :
                    <Link to={fields.linkGoToDetails + data.icn.id}>
                        <IconButton
                                iconClassName="material-icons">
                                forward
                        </IconButton>
                    </Link>
            }
        </div>

        );
    }
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        isExcelLoading: state.singleExcel.isLoading,
        isPdfLoading: state.singlePdf.isLoading,
        isCsvLoading: state.singleCsv.isLoading
    }
}

export default connect(mapStateToProps, {downloadSingleExcel, downloadSinglePdf, downloadSingleCsv})(LinkToDetailsExpandedCellRender);


// WEBPACK FOOTER //
// ./src/components/table/cellRenderers/LinkToDetailsExpandedCellRender.js